import { useId, useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { LANDING_PAGE_FAQ, LANDING_PAGE_SECTION, LANDING_PAGE_UI } from '@propbix/constants/public'
import { Reveal } from '@/components/Reveal'

export function FaqAccordion() {
  const baseId = useId()
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  return (
    <section
      id={LANDING_PAGE_SECTION.faq}
      className="section-band-muted"
      aria-labelledby="faq-heading"
    >
      <div className="page-shell section-y">
        <Reveal className="max-w-3xl">
          <p className="section-label">{LANDING_PAGE_UI.faqLabel}</p>
          <h2 id="faq-heading" className="section-title mt-3">
            {LANDING_PAGE_UI.faqTitle}
          </h2>
          <p className="section-body mt-5">{LANDING_PAGE_UI.faqSubtitle}</p>
        </Reveal>

        <div className="mx-auto mt-10 max-w-3xl divide-y divide-line/10 overflow-hidden rounded-[var(--radius-card)] border border-line/10 bg-panel">
          {LANDING_PAGE_FAQ.map((item, index) => {
            const expanded = openIndex === index
            const panelId = `${baseId}-panel-${index}`
            const buttonId = `${baseId}-button-${index}`
            return (
              <div key={item.question}>
                <h3>
                  <button
                    id={buttonId}
                    type="button"
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-base font-semibold text-ink hover:bg-surface md:px-6"
                    aria-expanded={expanded}
                    aria-controls={panelId}
                    onClick={() => setOpenIndex(expanded ? null : index)}
                  >
                    <span>{item.question}</span>
                    <ChevronDown
                      size={18}
                      strokeWidth={1.75}
                      className={expanded ? 'shrink-0 rotate-180 text-accent' : 'shrink-0 text-muted'}
                      aria-hidden
                    />
                  </button>
                </h3>
                <div
                  id={panelId}
                  role="region"
                  aria-labelledby={buttonId}
                  hidden={!expanded}
                  className="px-5 pb-5 text-base leading-7 text-muted md:px-6"
                >
                  {item.answer}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
